export const RECEIVE_INTERMEDIATE_RESULTS = Symbol(
	'RECEIVE_INTERMEDIATE_RESULTS'
);
